import React, { useEffect, useState } from "react";
import "../styles/home.css";

function Home() {
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const videoSrc = isPortrait
    ? "/homeimage/vertical2.mp4"  // video for mobile / portrait
    : "/homeimage/horizental2.mp4";          // video for laptop / landscape

  return (
    <div className="home">
      <video
        src={videoSrc}
        className="home-image"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="home-overlay"></div>
    </div>
  );
}

export default Home;
